module.exports = __webpack_public_path__ + "static/media/sort-up.0ab1ac43.svg";